type ScorablePerson = {
  firstName?: string | null;
  lastName?: string | null;
};

/** Vergleichsform eines Suchbegriffs oder Namensteils. */
export function normalizeSearchTerm(value: string | null | undefined): string {
  return (value || "").trim().toLowerCase();
}

/**
 * Trefferbewertung einer Person zu einem Suchbegriff, absteigend nach Genauigkeit:
 * vollständiger Name, Namensanfang, einzelner Name, Namensteil.
 *
 * Einzige Quelle für alle Masken, die Personen suchen — sonst führt derselbe Suchbegriff je nach
 * Einstiegspunkt zu einer anderen Trefferreihenfolge.
 */
export function scorePerson(person: ScorablePerson, term: string): number {
  const t = normalizeSearchTerm(term);
  if (!t) return 0;

  const firstName = normalizeSearchTerm(person.firstName);
  const lastName = normalizeSearchTerm(person.lastName);
  const full = [firstName, lastName].filter(Boolean).join(" ");
  const fullReversed = [lastName, firstName].filter(Boolean).join(" ");

  if (full === t || fullReversed === t) return 1000;
  if (full.startsWith(t) || fullReversed.startsWith(t)) return 800;
  if (lastName === t || firstName === t) return 700;
  if (lastName.startsWith(t) || firstName.startsWith(t)) return 650;
  if (full.includes(t) || fullReversed.includes(t)) return 500;
  if (lastName.includes(t) || firstName.includes(t)) return 450;
  return 0;
}

/** Trefferliste nach Bewertung sortiert; die Eingabeliste bleibt unverändert. */
export function sortPersonsByScore<T extends ScorablePerson>(list: T[] | null | undefined, term: string): T[] {
  return [...(list || [])].sort((a, b) => scorePerson(b, term) - scorePerson(a, term));
}
